import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { OtpField } from "@/components/OtpField";
import { api, formatError } from "@/lib/api";

export const VerifyCodeStep = ({ email, endpoint, onSuccess, resendEndpoint, resendBody }) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post(endpoint, { email, code });
      onSuccess(data);
    } catch (err) {
      setError(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  const resend = async () => {
    try {
      await api.post(resendEndpoint, resendBody);
      setNote("A new code is on its way.");
    } catch (err) {
      setError(formatError(err));
    }
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="verify-code-form">
      <p className="text-sm text-slate-600 dark:text-slate-300">We sent a 6-digit code to <strong>{email}</strong>.</p>
      <OtpField value={code} onChange={setCode} testId="auth-otp-input" />
      {error && <p data-testid="verify-code-error" className="text-sm text-red-600">{error}</p>}
      {note && <p className="text-sm text-emerald-600">{note}</p>}
      <Button data-testid="verify-code-submit" type="submit" disabled={busy || code.length !== 6} className="w-full h-11 rounded-full">
        {busy && <Loader2 className="animate-spin mr-2" size={16} />} Verify code
      </Button>
      {resendEndpoint && <button type="button" data-testid="resend-code-btn" onClick={resend} className="text-sm underline text-slate-500 hover:text-emerald-600">Resend code</button>}
    </form>
  );
};
